import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { startCheckout } from "../lib/checkout";
import { demoMarket, demoTrack, demoUtms } from "./demoMode";
import { useI18n } from "../i18n/LanguageContext";

let _pricing = null;
export function useDemoBuy() {
  const { lang } = useI18n();
  const [pricing, setPricing] = useState(_pricing);
  const [showSoon, setShowSoon] = useState(false);
  useEffect(() => { if (_pricing) return; api.get("/pricing").then(({ data }) => { _pricing = data; setPricing(data); }).catch(() => {}); }, []);
  const market = demoMarket();
  const current = pricing?.markets?.[market];
  const buy = (source) => {
    const meta = { source: `demo_${source}`, market, country: market, language: lang, landing_route: "/demo", displayed_currency: current?.currency, displayed_price: current?.amount, ...demoUtms() };
    demoTrack("cta_buy", meta);
    api.post("/analytics/event", { event: "click_buy", meta: { ...meta, version: "demo" } }).catch(() => {});
    startCheckout({ pricing, market, lang, meta: { ...meta, version: "demo" }, utm: demoUtms(), onSoon: () => setShowSoon(true) });
  };
  return { buy, current, showSoon, setShowSoon };
}
